import Phaser from 'phaser';

export class BeeSwarm {
    scene: Phaser.Scene;
    x: number;
    y: number;
    radius: number;
    duration: number;
    slowEffect: number;
    timeLeft: number;
    graphics: Phaser.GameObjects.Graphics;
    bees: { x: number; y: number; speed: number; angle: number }[];

    constructor(scene: Phaser.Scene, x: number, y: number, radius: number, duration: number, slowEffect: number = 0.7) {
        this.scene = scene;
        this.x = x;
        this.y = y;
        this.radius = radius;
        this.duration = duration;
        this.slowEffect = slowEffect;
        this.timeLeft = duration;
        this.graphics = scene.add.graphics();

        // Initialize bees for visual effect
        this.bees = [];
        for (let i = 0; i < 15; i++) {
            this.bees.push({
                x: (Math.random() - 0.5) * radius * 2,
                y: (Math.random() - 0.5) * radius * 2,
                speed: 26 + Math.random() * 39,
                angle: Math.random() * Math.PI * 2
            });
        }
    }

    update(delta: number): boolean {
        this.timeLeft -= delta;
        if (this.timeLeft <= 0) {
            this.destroy();
            return false; // Swarm expired
        }

        // Update visuals
        this.graphics.clear();

        // Draw swarm area (faint yellow)
        this.graphics.fillStyle(0xffd700, 0.2);
        this.graphics.fillCircle(this.x, this.y, this.radius);

        // Draw bees
        this.graphics.fillStyle(0x000000, 1);
        for (const bee of this.bees) {
            // Move bees chaotically
            bee.angle += (Math.random() - 0.5) * 0.5;
            bee.x += Math.cos(bee.angle) * bee.speed * (delta / 1000);
            bee.y += Math.sin(bee.angle) * bee.speed * (delta / 1000);

            // Keep within radius
            const dist = Math.sqrt(bee.x * bee.x + bee.y * bee.y);
            if (dist > this.radius) {
                // Bounce back
                const angleToCenter = Math.atan2(-bee.y, -bee.x);
                bee.angle = angleToCenter + (Math.random() - 0.5);
            }

            // Draw bee (black dot for now, or yellow/black)
            this.graphics.fillRect(this.x + bee.x, this.y + bee.y, 2, 2);
            this.graphics.fillStyle(0xffff00, 1);
            this.graphics.fillRect(this.x + bee.x - 1, this.y + bee.y - 1, 1, 1);
            this.graphics.fillStyle(0x000000, 1);
        }

        return true; // Still active
    }

    destroy(): void {
        this.graphics.destroy();
    }
}
